const webfonts = require('./webfonts')

module.exports.allFonts = Object.keys(webfonts)

module.exports.allFontsHash = webfonts
